import React from 'react';
import { connect } from 'react-redux';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

import { Typography, Grid, Button } from '@material-ui/core';

import CONFIG from '../../cfg/config';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import MailIcon from '@material-ui/icons/Mail'
import CallIcon from '@material-ui/icons/Call'
import HomeIcon from '@material-ui/icons/Home'
import GpsIcon from '@material-ui/icons/GpsFixed'


import ResponsiveImgMaterialUi from "responsive-img-material-ui";
import theme from '../../themes';
import { store, Actions, AppState, IPageState, DisplayWindow } from '../../appredux';

//PM 2021-11-25
//usuniecie page
//poprawka typow
interface KontaktProps extends WithStyles<typeof styles> {
  page: IPageState;
  data: {
    title: string;
    email: string;
    phone: string;
    gps: string;
    address: string;
},
  logo?: any,
  titleSize?: string,
  fontSize?: string,
  iconSize?: string,
  color?: string,
}



class Kontakt extends React.Component<KontaktProps> {
  logoUrl: string = `${CONFIG.apiURL}/hotel/image/${CONFIG.hotelID}/logo.png`

  openMap = async () => {
    if(this.props.page.mapaGps !== this.props.data.gps){
      await store.dispatch(Actions.pageState.setMapaGps(this.props.data.gps));
    }
    await store.dispatch(Actions.pageState.setDisplayWindow(DisplayWindow.Map))
  } 

  render() {
    const classes = this.props.classes;
    const {  logo = '', titleSize = "14px", fontSize = "13px", iconSize = "16px", color = theme.palette.primary.main } = this.props;

    //let mapLink = `https://www.openstreetmap.org/#map=18/${this.props.data.gps.split(" ")[0]}/${this.props.data.gps.split(" ")[1]}`
    //let mapLink = `https://www.openstreetmap.org/directions?from=${this.props.data.gps.split(" ")[0].substring(0, 10)}%2C${this.props.data.gps.split(" ")[1].substring(0, 10)}&to=`

    return (
        <Grid item xs={12} md={6} className={classes.leftGrid}>
          <Typography variant="h6" component="h2" color="primary" style={{ paddingBottom: "15px", fontWeight: "bold", fontSize: titleSize }}>
            {this.props.data.title}
            </Typography>
          <hr />
          <div className={classes.tableContainer}>
            <Table>
              <TableBody>
                <TableRow >
                  <TableCell align="left" style={{ width: "90px" }}
                    className={classes.cell}>
                    <Typography variant="h6" component="h2">
                      <MailIcon className={`${classes.iconLeft} `} style={{ marginBottom: "-4px", fontSize: iconSize, color: this.props.color }} />
                      <span className={classes.title} style={{fontSize: fontSize, color: this.props.color}} >
                        email:
                  </span>
                    </Typography>
                  </TableCell>
                  <TableCell align="right" className={classes.cell}>
                    <Typography variant="h6" component="h2" color='primary' style={{fontSize: fontSize, color: this.props.color}}>
                      <a href={`mailto:${this.props.data.email}`} className={classes.email}>{this.props.data.email}</a>
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow >
                  <TableCell align="left" style={{ width: "100px" }}
                    className={classes.cell}>
                    <Typography variant="h6" component="h2" >
                      <CallIcon className={`${classes.iconLeft} `} style={{ marginBottom: "-4px", fontSize: iconSize, color: this.props.color }} />
                      <span className={classes.title} style={{fontSize: fontSize, color: this.props.color}}>
                        telefon:
                  </span>
                    </Typography>
                  </TableCell>
                  <TableCell align="right" className={classes.cell}>
                    <Typography variant="h6" component="h2" color='primary' style={{fontSize: fontSize, color: this.props.color}}>
                      <a href={`tel:${this.props.data.phone}`} className={classes.email}>{this.props.data.phone}</a>
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow >
                  <TableCell align="left" style={{ width: "90px" }}
                    className={classes.cell}>
                    <Typography variant="h6" component="h2" >
                      <GpsIcon className={`${classes.iconLeft} `} style={{ marginBottom: "-4px", fontSize: iconSize, color: this.props.color }} />
                      <span className={classes.title} style={{fontSize: fontSize, color: this.props.color}}>
                        gps:
                  </span>
                    </Typography>
                  </TableCell>
                  <TableCell align="right" className={classes.cell}  >
                    <Typography variant="h6" component="h2" color='primary' style={{fontSize: fontSize, color: this.props.color}}>
                      {/* <a href={mapLink} target="_blank" className={classes.email}>{this.props.data.gps}</a> */}
                      <Button
                        variant="text"
                        onClick={() =>this.openMap()}
                        className={`${classes.email} ${classes.gpsButton}`}
                      >
                        {this.props.data.gps}
                      </Button>
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow >
                  <TableCell align="left" style={{ width: "90px" }}
                    className={classes.cell}>
                    <Typography variant="h6" component="h2" >
                      <HomeIcon className={`${classes.iconLeft} `} style={{ marginBottom: "-4px", fontSize: iconSize, color: this.props.color }} />
                      <span className={classes.title} style={{fontSize: fontSize, color: this.props.color}}>
                        adres:
                  </span>
                    </Typography>
                  </TableCell>
                  <TableCell align="right" className={classes.cell}>
                    <Typography variant="h6" component="h2" color='primary' style={{fontSize: fontSize, color: this.props.color}}>
                    {this.props.data.address}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
          <Typography variant="h6" component="h2" color="primary">
            <p></p>
          </Typography>
          {/* <Typography
            variant="h6" component="h2" color="primary"
            dangerouslySetInnerHTML={{ __html: this.props.page.kontakt[0].info }}
          /> */}
          {logo !== '' ?
            <div className={classes.pictureContainer}>
              <ResponsiveImgMaterialUi style={{ margin: "auto", display: "block", position: "relative", top: "50%", transform: "translateY(-50%)", width: "40%" }}
                xs={this.props.logo}
                md={this.props.logo}
                lg={this.props.logo}
              />
            </div>
          : null }
        </Grid>
    )
  }
}

const styles = (theme: Theme) => ({
  email: {
    color: "inherit",
    "&:hover": {
      textDecoration: "underline"
    }
  },
  title: {
     marginLeft:"1em",
     marginRight:"1em",
     fontSize: "13px"
  },
  iconLeft: {
    backgroundColor : theme.palette.background.default,
    color : "#5F9EA0"
  },
  iconRight: {
    backgroundColor : theme.palette.background.default,
    color : theme.palette.primary.main
  },
  text: {
    color: theme.palette.text.primary
  },
  cell: {
    padding: "7px 5px 7px 5px", 
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
    color: theme.palette.text.primary
  },
  tableText: {
    fontSize: "13px"
  },
  pictureContainer: {
    height: "150px",
    position: "relative" as "relative"
  },
  tableContainer: {
    paddingLeft: "10px",
    paddingRight: "10px"
  },
  leftGrid: {
    paddingLeft: "15px",
    paddingRight: "15px"
  },
  "@media screen and (max-width: 960px)": {
    leftGrid: {
      paddingLeft: "0px",  
      paddingRight: "0px"
    },
  },
  gpsButton: {
    padding: 0,
    fontSize: '13px',
    lineHeight: '1.6',
    fontWeight: "normal" as "normal",
    //letterSpacing: '0.09px',
    "&:hover": {
      background: 'none'
    }
  }
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withStyles(styles)(Kontakt));